export enum AppointmentType {
  Normal = 'Normaal',
  Orientation = 'Orientatie'
}
